import React from 'react'
import { MdNavigateNext } from "react-icons/md"


function Menu() {
    const style = { color: "#000", width: "25px", height: "20px", position: "absolute",top:"5px;",right:"15px",bottom:"10px", }

    return (
        <>
            <section className="menu-container">
                <button className="Features-btn"><a className="Feat-btn" href="./">Features</a><MdNavigateNext style={style}/></button>
                <button className="Company-btn"><a className="Comp-btn" href="#">Company</a><MdNavigateNext style={style}/></button>
                <button className="Community-btn"><a className="Commu-btn" href="./Community">Community</a><MdNavigateNext style={style}/></button>
                <button className="Pricing-btn"><a className="Price-btn" href="#">Pricing</a><MdNavigateNext style={style}/></button>
                <button className="Learn-btn"><a className="L-btn" href="./blog">Learn</a><MdNavigateNext style={style}/></button>
                <button className="Lo-btn"><a className="lo-btn" href="./Login">Login</a></button>
                <button className="btnGt"><a className="Gtbtn" href="./SignUp">Get Started</a></button>
            </section>

        </>

    )
}

export default Menu
